import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Coverage } from "@/components/landing/Coverage";
import { Model22p } from "@/components/landing/Model22p";
import { Objections } from "@/components/landing/Objections";
import { CaseStudy } from "@/components/landing/CaseStudy";
import { EnquiryForm } from "@/components/landing/EnquiryForm";
import { Faq } from "@/components/landing/Faq";
import { About } from "@/components/landing/About";

export default function Landing() {
  return (
    <div data-testid="landing-page">
      <Nav dark />
      <Hero />
      <Marquee />
      <HowItWorks />
      <Coverage />
      <Model22p />
      <Objections />
      <CaseStudy />
      <EnquiryForm />
      <Faq />
      <About />
      <Footer />
    </div>
  );
}
